// @ts-check
/**
 * TODO: Delete useGetCompletedTransactionHistory and useGetPendingTransactionHistory and all it's dependencies
 * after this goes into production and demonstrating the legacy hooks are
 * no longer needed.
 */
import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { getTransactionHistoryWithFilters } from ".";
import { cacheEachTxnFromList } from "./utils";

/**
 * useGetTransactionsWithFilters custom hook to wrap useQuery with getTransactionHistoryWithFilters
 * @param {string} accountId 
 * @param {object} filters
 * @param {Array<string>} [filters.types]
 * @param {Array<string>} [filters.statuses]
 * @param {number | undefined} [filters.page]
 * @param {number | undefined} [filters.limit]
 * @returns {import("@tanstack/react-query").UseQueryResult}
 */
export default function useGetTransactionsWithFilters(accountId, { types, statuses, page, limit }) {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();

  const fetchTransactionHistory = useCallback(async () => {
    const data = await getTransactionHistoryWithFilters(sessionJWT, accountId, {
      types,
      statuses,
      limit,
      offset: Number.isInteger(page) && Number.isInteger(limit) ? page * limit : undefined,
    });
    const txns = data.payload?.transactions || [];
    cacheEachTxnFromList(txns, queryClient);
    return data;
  }, [sessionJWT, accountId, types, statuses, limit, page, queryClient]);

  return useQuery({
    queryKey: ["transactions", accountId, { types, statuses }, page],
    queryFn: fetchTransactionHistory,
    refetchOnMount: false, // TODO: When this endpoint has been optimized, remove this
  });
}
